var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.componentType,_vm._b({tag:"component",class:_setup.buttonClasses,on:{"click":_setup.handleClick}},'component',_setup.componentAttrs,false),[_c('span',{class:[
        'tw:flex tw:items-center tw:gap-2 tw:w-full',
        _vm.align === 'left' ? 'tw:justify-start tw:text-left' : 'tw:justify-center tw:text-center'
    ]},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin tw:flex tw:items-center"}):(_vm.icon)?_c('i',{staticClass:"tw:flex tw:items-center",class:_vm.icon}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }